var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 490.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,0C114.56,0,0,112.64,0,251.56,0,362.73,73.34,457,175,490.24c12.8,2.37,17.49-5.42,17.49-12.1,0-6-.21-21.8-.32-42.77C121,450.54,106,401.62,106,401.62c-11.64-29-28.48-36.8-28.48-36.8-23.19-15.59,1.8-15.27,1.8-15.27,25.7,1.75,39.21,25.92,39.21,25.92,22.82,38.46,59.92,27.35,74.56,20.92,2.3-16.27,8.89-27.34,16.21-33.64-56.85-6.29-116.61-27.92-116.61-124.31,0-27.45,9.92-49.9,26.35-67.5-2.88-6.35-11.52-31.93,2.24-66.58,0,0,21.44-6.74,70.4,25.79a245.47,245.47,0,0,1,128,0c48.64-32.53,70.08-25.79,70.08-25.79,13.76,34.65,5.12,60.23,2.56,66.58,16.32,17.6,26.24,40.05,26.24,67.5,0,96.64-59.84,117.91-116.8,124.1,9,7.55,17.28,23,17.28,46.55,0,33.66-.32,60.71-.32,68.88,0,6.6,4.48,14.47,17.6,11.95C438.72,456.9,512,362.56,512,251.56,512,112.64,397.38,0,256,0Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/github-logo.be97366fa3794a8532302ea2cf8e6411.svg";
export { ForwardRef as ReactComponent };